module.exports = __webpack_public_path__ + "static/media/book.f7cc1fbd.jpg";